import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=283211ce&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283211ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('283211ce')) {
      api.createRecord('283211ce', component.options)
    } else {
      api.reload('283211ce', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=283211ce&scoped=true&", function () {
      api.rerender('283211ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-260B8xsSiTrTi/JS/comp/Accordion.vue"
export default component.exports